import {ListItemText} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import React, {Fragment, useState} from "react";
import {OrganizationUnitSelectorDialog} from "../../../_shared/organization-unit-selector/OrganizationUnitSelectorDialog";
import {useTranslation} from "react-i18next";
import {Machine} from "../../../../models/machine.models";
import {moveMachines} from "../../../../api/machine-functions";
import {useNotification} from "../../../ui/notification/NotificationProvider";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import * as _ from "lodash";
import {OrgUnit} from "../../../../models/organization";

interface Props {
    organizationId: number,
    machine: Machine,
    onMoved: () => void,
    onActionCompleted: () => void
}

export const MoveMachineAction: React.FC<Props> = ({organizationId, machine, onMoved, onActionCompleted}) => {
    const {t} = useTranslation();
    const [openDestinationOrgUnitSelection, setOpenDestinationOrgUnitSelection] = useState(false);
    const [disable, setDisable] = useState(false);
    const {pushError} = useNotification();
    const {showSuccess} = useApiNotification();

    const moveMachineToTarget = async (orgUnit: OrgUnit) => {
        setDisable(true);
        await moveMachines({
            userId: machine.id,
            sourceOrgUnitId: machine.organizationUnitId,
            targetOrgUnitId: orgUnit.id
        }).then(() => {
            showSuccess();
            onMoved();
        }).catch(e => {
            const errorType = _.get(e, 'response.data.error.type') || 'UnknownError';
            pushError({
                message: t(`_Common.Api.Messages.${errorType}`)
            });
        }).finally(() => {
            setOpenDestinationOrgUnitSelection(false);
            onActionCompleted();
        });
    }
    return <Fragment>
        <ListItem onClick={() => setOpenDestinationOrgUnitSelection(true)}>
            <ListItemText style={{cursor: 'pointer'}}>
                {t('Machine.Actions.MoveMachine.Title')}
            </ListItemText>
        </ListItem>
        <OrganizationUnitSelectorDialog
            open={openDestinationOrgUnitSelection}
            organizationId={organizationId}
            onSelectOrgUnit={moveMachineToTarget}
            onCancel={() => {
                setOpenDestinationOrgUnitSelection(false);
                onActionCompleted();
            }}
            disabled={disable}
        />
    </Fragment>
}
